import { createContext } from 'react'

// creates the context that will be imported
// and referenced by a child component;
// comparable to createStore() in redux
const HarvestContext = createContext()

export default HarvestContext
